import { Typography } from 'antd';
import { AnnouncementHistory } from '@annea/announcements-ui';
import { API_BASE } from '../lib/api';

export default function AnnouncementsPage() {
  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      <Typography.Title level={2}>News and service updates</Typography.Title>
      <Typography.Paragraph type="secondary">
        Current and previous announcements relevant to your Annea applications.
      </Typography.Paragraph>
      <AnnouncementHistory apiUrl={API_BASE} channel="apo" />
    </div>
  );
}
